import React from "react";

import MetaTags from "react-meta-tags";

const GoogleCloudServer = () => {
  return (
    <div>
      <MetaTags>
        <title>Set Title</title>
        <meta
          name="description"
          content="Idatahost is the best web hosting provider"
        />
      </MetaTags>
      <div className="main">
        {/*hero section start*/}
        <section className="ptb-120 gradient-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7 col-lg-6">
                <div className="hero-content-wrap text-white">
                  <h1 className="text-white">
                    Google Cloud Service at your Doorstep
                  </h1>
                  <p className="lead">
                    Google cloud has made choose a fine-tuned hosting services
                    solution for successful personal and business websites.
                  </p>
                  <a href="#" className="btn btn-brand-03 btn-lg">
                    Get Start Now
                  </a>
                </div>
              </div>
              <div className="col-md-5 col-lg-6">
                <div className="img-wrap">
                  <img
                    src="assets/img/hero-cloud-hosting.svg"
                    alt="vps image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*hero section end*/}

        {/*compare pricing table start*/}
        <section className="compare-pricing-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2>Packages Details</h2>
                  <p className="lead">
                    Globally incubate next-generation e-services via state of
                    the art technology. Appropriately iterate quality.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table w-100 table-hover table-bordered comparision-table text-center">
                    <thead className="comparision-table-head">
                      <tr className="active">
                        <th className="text-left">
                          <p className="mb-0">
                            <strong>Choose your plan</strong>
                          </p>
                          <small>
                            <a href="#">Or Chat with an expert</a>
                          </small>
                        </th>
                        <th>
                          <strong className="h5 mb-0">Basic Plan</strong>
                          <p className="text-muted text-sm">
                            For Small Business
                          </p>
                        </th>
                        <th>
                          <strong className="h5 mb-0">
                            Baby Plan
                            <span className="badge color-1 color-1-bg">
                              Popular
                            </span>
                          </strong>
                          <p className="text-muted text-sm">
                            For Medium Business
                          </p>
                        </th>
                        <th>
                          <strong className="h5 mb-0">Business Plan</strong>
                          <p className="text-muted text-sm">
                            For Large Business
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="comparision-table-body">
                      <tr>
                        <td>
                          <p className="mb-0 comparision-price-title text-left">
                            <strong>Price</strong>
                          </p>
                        </td>
                        <td className="py-4">
                          <h4 className="mb-0 comparision-price">
                            $2.5 <span>/month</span>
                          </h4>
                          <a href="#" className="btn btn-brand-01 btn-xs mt-2">
                            Get Started
                          </a>
                        </td>
                        <td className="py-4">
                          <h4 className="mb-0 comparision-price">
                            $3.99 <span>/month</span>
                          </h4>
                          <a href="#" className="btn btn-brand-01 btn-xs mt-2">
                            Get Started
                          </a>
                        </td>
                        <td className="py-4">
                          <h4 className="mb-0 comparision-price">
                            $5.99 <span>/month</span>
                          </h4>
                          <a href="#" className="btn btn-brand-01 btn-xs mt-2">
                            Get Started
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            24/7/365 Support
                          </p>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            Instant Backups
                          </p>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            No Contract
                          </p>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            99.9% Uptime guarantee
                          </p>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            Google Adwords
                          </p>
                        </td>
                        <td>$50 Credit</td>
                        <td>$75 Credit</td>
                        <td>$100 Credit</td>
                      </tr>

                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">Bing</p>
                        </td>
                        <td>$50 Credit</td>
                        <td>$75 Credit</td>
                        <td>$100 Credit</td>
                      </tr>

                      <tr>
                        <td>
                          <p className="text-left font-weight-bold">
                            Free/Instant Setup
                          </p>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                        <td>
                          <span className="ti-check color-primary"></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*compare pricing table end*/}

        {/*feature section start*/}
        <section className="cta-new ptb-100 gray-light-bg">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <h2> Google Cloud Hosting Is Faster, Stronger, Dedicated</h2>
                  <p className="lead">
                    Globally parallel task granular alignments through excellent
                    intellectual capital. Globally deploy vertical leadership.
                  </p>
                  <ul className="list-unstyled tech-feature-list">
                    <li className="py-1">
                      <span className="ti-control-forward mr-2 color-primary"></span>
                      Flexible, Easy to Use Control Panel
                    </li>
                    <li className="py-1">
                      <span className="ti-control-forward mr-2 color-primary"></span>
                      <strong>Unmetered</strong> Bandwidth
                    </li>
                    <li className="py-1">
                      <span className="ti-control-forward mr-2 color-primary"></span>
                      <strong>Unmetered</strong> Sub Domains, FTP Accounts
                    </li>
                    <li className="py-1">
                      <span className="ti-control-forward mr-2 color-primary"></span>
                      <strong>99%</strong> Uptime Guarantee
                    </li>
                    <li className="py-1">
                      <span className="ti-control-forward mr-2 color-primary"></span>
                      <strong>45-Day</strong> Money-Back Guarantee
                    </li>
                  </ul>
                  <div className="action-btns mt-4">
                    <a href="#" className="btn btn-brand-01">
                      Get Started Now
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <img
                    src="assets/img/private-cloud-server.svg"
                    alt="hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="feature-tab-section ptb-100">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <img
                    src="assets/img/easy-to-transfer.svg"
                    alt="hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <h2>The Perfect Environment For Your Success</h2>
                  <div className="feature-feature-list py-3">
                    <h5 className="mb-2">Room for Growth</h5>
                    <p>
                      One of many premium features is a dedicated IP cheapest
                      VPS hosting plan Authoritatively formulate user-centric
                      sources without emerging best practices. Monotonectally
                      morph an expanded
                    </p>
                  </div>
                  <div className="feature-feature-list py-3">
                    <h5 className="mb-2">3x More Speed</h5>
                    <p>
                      Our VPS hosting plan is fully packed with dedicated IPv6
                      Internet protocol IP Progressively maximize standardized
                      catalysts for change via diverse initiatives.
                      Monotonectally underwhelm
                    </p>
                  </div>
                  <div className="feature-feature-list py-3">
                    <h5 className="mb-2">Powerful Control Panel</h5>
                    <p>
                      If you’re not 100% satisfied with Hostlar, we’ll refund
                      your payment no risk Interactively administrate wireless
                      results via cooperative mindshare. Completely benchmark
                      process-centric sources and high standards
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*feature section end*/}

        {/*call to action new style start*/}
        <section className="ptb-60 primary-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-12 col-lg-6">
                <div className="cta-content-wrap text-white">
                  <h2 className="text-white">
                    24/7 Expert Hosting Support Our Customers Love
                  </h2>
                  <p>
                    Objectively innovate high compellingly maintain
                    progressively pursue mission-critical information quality
                    imperatives.
                  </p>
                </div>
                <div className="support-action d-inline-flex flex-wrap">
                  <a href="mailto:support@yourdomain.com" className="mr-3">
                    <i className="fas fa-comment mr-1 color-accent"></i>
                    <span>support@idatahost.com</span>
                  </a>
                  <a href="tel:+00123456789" className="mb-0">
                    <i className="fas fa-phone-alt mr-1 color-accent"></i>
                    <span>+880 1400 88 34 00</span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 d-none d-lg-block">
                <div className="cta-img-wrap text-center">
                  <img
                    src="assets/img/call-center-support.svg"
                    width="250"
                    className="img-fluid"
                    alt="server room"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*call to action new style end*/}

        {/*network map section start*/}
        <section className="network-map-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2>Google Data Center Locations</h2>
                  <p className="lead">
                    Cloudhub offers a low latency worldwide network, enabling
                    you to deploy your service infrastructure in close proximity
                    to your customer base.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="network-map-wrap">
                  <ul className="custom-map-location">
                    <li style={{ top: "29%", left: "15.5%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Canada"></span>
                    </li>
                    <li style={{ top: "42%", left: "20%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="United States"></span>
                    </li>
                    <li style={{ top: "70%", left: "32%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Brazil"></span>
                    </li>
                    <li style={{ top: "57%", left: "48%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Nigeria"></span>
                    </li>
                    <li style={{ top: "18%", left: "53%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Finland"></span>
                    </li>
                    <li style={{ top: "34%", left: "55%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Ukraine"></span>
                    </li>
                    <li style={{ top: "45%", left: "68%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="India"></span>
                    </li>
                    <li style={{ top: "35%", left: "80%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="China"></span>
                    </li>
                    <li style={{ top: "77%", left: "85%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Australia"></span>
                    </li>
                    <li style={{ top: "20%", left: "70%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Russia"></span>
                    </li>
                    <li style={{ top: "30%", left: "30%" }}>
                      <span
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Italy"></span>
                    </li>
                  </ul>
                  <img src="assets/img/map-dark.svg" alt="location map" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*network map section end*/}

        {/*faq new style start*/}
        <section id="faq" className="ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2>Frequently Asked Queries</h2>
                  <p>
                    Efficiently productivate reliable paradigms before
                    ubiquitous models. Continually utilize frictionless
                    expertise whereas tactical relationships. Still have
                    questions? Contact us
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-12">
                <div id="accordion" className="accordion faq-wrap">
                  <div className="card mb-3">
                    <a
                      className="card-header"
                      data-toggle="collapse"
                      href="#collapse0"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        Which license do I need?
                      </h6>
                    </a>
                    <div
                      id="collapse0"
                      className="collapse show"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table, raw denim aesthetic synth nesciunt
                          you probably haven&#x27;t heard of them accusamus
                          labore sustainable VHS.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card my-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse1"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        How do I get access to a theme?
                      </h6>
                    </a>
                    <div
                      id="collapse1"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Ad vegan excepteur butcher vice lomo. Leggings
                          occaecat craft beer farm-to-table, raw denim aesthetic
                          synth nesciunt you probably haven&#x27;t heard of them
                          accusamus. Seamlessly optimize empowered testing
                          procedures before revolutionary processes.
                          Progressively facilitate client-centered technologies
                          whereas extensive users. Authoritatively.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card my-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse2"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        How do I see previous orders?
                      </h6>
                    </a>
                    <div
                      id="collapse2"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table, raw denim aesthetic synth nesciunt
                          you probably haven&#x27;t heard of them accusamus
                          labore sustainable VHS.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse3"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        Support related issues for the template?
                      </h6>
                    </a>
                    <div
                      id="collapse3"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table. Professionally embrace customer
                          directed value vis-a-vis high-quality portals. Quickly
                          underwhelm B2C users with maintainable benefits.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*faq new style end*/}

        {/*testimonial and review section start*/}
        <section className="review-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-7">
                <div className="section-heading text-center">
                  <h2>Our Lovely Client Say About Us</h2>
                  <p>
                    Uniquely repurpose strategic core competencies with
                    progressive content. Assertively transition ethical
                    imperatives and collaborative manufactured products.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="owl-carousel owl-theme client-testimonial-1 dot-bottom-center custom-dot">
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Amazing template</h5>
                      <p>
                        Distinctively foster maintainable metrics whereas
                        multidisciplinary process improvements. Objectively
                        implement strategic niches through.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-2.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Best template for app</h5>
                      <p>
                        Efficiently innovate customized growth strategies
                        whereas error-free paradigms. Monotonectally enhance
                        stand-alone data with prospective innovation.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-1.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Tony Roy</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Efficiently innovate app</h5>
                      <p>
                        Continually redefine sticky channels whereas extensive
                        "outside the box" thinking. Rapidiously supply focused
                        schemas vis-a-vis optimal users.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-3.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Uniquely mesh flexible</h5>
                      <p>
                        Phosfluorescently optimize intermandated platforms
                        without integrated infrastructures. Proactively redefine
                        granular thinking before.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-4.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Compellingly empower app</h5>
                      <p>
                        Proactively grow focused niche markets with virtual
                        e-services. Rapidiously pursue effective ROI via
                        holistic information completely reintermediate.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-2.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Holisticly reintermediate</h5>
                      <p>
                        Collaboratively reintermediate out-of-the-box e-business
                        via economically sound supply chains. Dynamically target
                        client-based holistic information.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-1.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Uniquely mesh flexible</h5>
                      <p>
                        Phosfluorescently optimize intermandated platforms
                        without integrated infrastructures. Proactively redefine
                        granular thinking before.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-3.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Compellingly empower app</h5>
                      <p>
                        Proactively grow focused niche markets with virtual
                        e-services. Rapidiously pursue effective ROI via
                        holistic information completely reintermediate.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-1.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="border single-review-wrap bg-white p-4 m-3">
                    <div className="review-body">
                      <h5>Holisticly reintermediate</h5>
                      <p>
                        Collaboratively reintermediate out-of-the-box e-business
                        via economically sound supply chains. Dynamically target
                        client-based holistic information.
                      </p>
                    </div>
                    <div className="review-author d-flex align-items-center">
                      <div className="author-avatar">
                        <img
                          src="assets/img/client-2.jpg"
                          width="64"
                          alt="author"
                          className="rounded-circle shadow-sm img-fluid mr-3"
                        />
                        <span>“</span>
                      </div>
                      <div className="review-info">
                        <h6 className="mb-0">Ana Joly</h6>
                        <span>BizBite</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*testimonial and review section end*/}
      </div>
    </div>
  );
};

export default GoogleCloudServer;
